import { onDocumentReady } from '../utils/events';

onDocumentReady(() => {
  $('a[href*="#"]').on('click', function (e) {
    const url = $(this).attr('href');

    // WordPress stores menu links as absolute URLs, so resolve first and only
    // bail on a genuinely different origin or page.
    let link;
    try {
      link = new URL(url, window.location.href);
    } catch (err) {
      return;
    }

    if (link.origin !== window.location.origin) return;
    if (!link.hash || link.hash === '#') return;
    if (link.pathname !== window.location.pathname) return;

    const $target = $(link.hash);

    if (!$target.length) return;

    e.preventDefault();

    $('html, body').removeClass('menu-open');
    $('.menu-icon').removeClass('is-active');
    $('.top-bar').removeClass('is-active');

    setTimeout(function () {
      // Clear the fixed header plus a little breathing room, so the section
      // heading isn't sitting flush under it on arrival.
      const offset = ($('.header').outerHeight() || 0) + 24;

      $('html, body').animate(
        { scrollTop: $target.offset().top - offset },
        600
      );
    }, 50);
  });

  const currentPath = window.location.pathname;

  if (currentPath === '/') {
    $(
      'li.current-menu-item a[href*="#"], li.current_page_item a[href*="#"]'
    ).each(function () {
      const url = $(this).attr('href');

      if (url.startsWith('/#')) {
        const $listItem = $(this).parent('li');

        $listItem.removeClass('current-menu-item current_page_item');

        $(this).removeAttr('aria-current');
      }
    });
  }
});
